<template>

        <div>
          <div class="tabular-header custom-grid-timeline">
            <div>Index</div>
            <div>Hora</div>
            <div>ID</div>
            <div>Tipo</div>
            <div>Quantidade</div>
            <div>Preço</div>
            <div>Estratégia</div>
            <div>Status</div>
            <div>PriceRef</div>
          </div>

          <div class="timeline-executions scrollable">
            <div v-for="(event, index) in timelineEvents" :key="event.eventID" class="tabular-row custom-grid-timeline">
              <div>{{ timelineEvents.length - index }}</div>
              <div>{{ formatDate(event.orderData.timestamp) }}</div>
              <div>{{ event.orderData.clientID }}</div>
              <div :class="['order-side', 'order-' + event.orderData.side]">{{ event.orderData.side }}</div>
              <div :class="['qty-cell', event.orderData.side === 'buy' ? 'qty-buy' : 'qty-sell']">{{ event.orderData.qty }}</div>
              <div class="order-price">{{ event.orderData.price }}</div>
              <div><span :class="['bucket-badge', 'bucket-' + event.orderData.strategy]">{{ event.orderData.strategy }}</span></div>
              <div><span :class="['status-badge', 'status-' + event.orderData.status]">{{ event.orderData.status }}</span></div>
              <div class="order-price">{{ event.orderData.priceRef }}</div>
            </div>
          </div>
        </div>

</template>

<script>
import { mapState } from 'vuex';
import {formatDate} from '../utils/funcs.js'

export default {
  name: "timelineExecutions",
  computed: {
    ...mapState({
        timeline: state => (state && state.eventLogs) ? state.eventLogs : {},
    }),
    timelineEvents() {
      // Supondo que cada evento tem timeExec, side, price, strategy, profit, percent, qty
      return Object.entries(this.timeline || {}).map(([eventID, event]) => ({ eventID, ...event })).reverse(); // Mais recente primeiro
    }
  },
  methods: {
    formatDate,
  },
};
</script>

<style>
.timeline-executions {
  background-color: var(--table-header-bgcolor);
  color: var(--text-color);
  border-radius: 10px;
  height: 362px;
}

.custom-grid-timeline {
  /*deve ser colocado no tabular-header e tabular-row*/
  display: grid;
  grid-template-columns: 0.4fr 0.8fr 2fr 0.5fr 1.1fr 0.7fr 0.6fr 0.6fr 0.7fr !important;
}

.order-price {
  font-size: 1rem;
}

</style>
